var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningIcon = function SvgWarningIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00049 17.5H17.0538C18.5932 17.5 19.5527 15.8307 18.7831 14.5013L11.2564 1.49706C10.4867 0.167647 8.56759 0.167647 7.79793 1.49706L0.271252 14.5013C-0.498409 15.8307 0.461167 17.5 2.00049 17.5ZM9.52717 10.5031C8.97741 10.5031 8.52761 10.0533 8.52761 9.50353V7.50441C8.52761 6.95465 8.97741 6.50485 9.52717 6.50485C10.0769 6.50485 10.5267 6.95465 10.5267 7.50441V9.50353C10.5267 10.0533 10.0769 10.5031 9.52717 10.5031ZM10.5267 14.5013H8.52761V12.5022H10.5267V14.5013Z",
    fill: "#FF8C00"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning-icon.1be584f3a7fb50b4aee84bfd9fe5d68b.svg";